import { z } from "zod";
/** Kids'-age filter buckets (months, inclusive start / exclusive end). */
export const AGE_BUCKETS = [
    { key: "baby", label: "Baby (0–1)", min: 0, max: 12 },
    { key: "toddler", label: "Toddler (1–3)", min: 12, max: 36 },
    { key: "preschool", label: "Preschool (3–5)", min: 36, max: 60 },
    { key: "bigkids", label: "Big kids (5+)", min: 60, max: 216 },
];
export function bucketForMonths(m) {
    return (AGE_BUCKETS.find((b) => m >= b.min && m < b.max) ?? AGE_BUCKETS[3]).key;
}
/** "Ages 6 mo–6 yrs" / "Ages 1–8 yrs" / "Ages 5+" from a month range. */
export function ageRangeLabel(minMonths, maxMonths) {
    if (minMonths <= 0 && maxMonths >= 216)
        return "All ages";
    const lo = minMonths < 12 ? `${minMonths} mo` : `${Math.floor(minMonths / 12)}`;
    if (maxMonths >= 216)
        return `Ages ${lo}+`;
    const hi = maxMonths < 24 ? `${maxMonths} mo` : `${Math.floor(maxMonths / 12)} yrs`;
    return `Ages ${lo}–${hi}`;
}
export const placeSuggestionBodyV2 = z.object({
    name: z.string().trim().min(2).max(120),
    address: z.string().trim().min(3).max(200),
    why: z.string().trim().max(1000).default(""),
});
//# sourceMappingURL=places.js.map